// components/ImageZoomModal.tsx
import CustomModal from '../components/CustomModal';
import { MAX_ZOOM, MIN_ZOOM, ZOOM_STEP } from '../constant/constant';
import useHandleZoom from '../hooks/usehandleZoom';
import { useState } from 'react';

interface ImageZoomModalProps {
  isOpen: boolean;
  imageUrl: string;
  onClose: () => void;
}

export default function ImageZoomModal({
  isOpen,
  imageUrl,
  onClose,
}: ImageZoomModalProps) {
  const [zoom, setZoom] = useState(MIN_ZOOM);
  const {
    handleTouchMove,
    handleTouchStart,
    position,
    setPosition,
    setDragging,
  } = useHandleZoom(zoom);

  const handleClose = () => {
    onClose();
    setZoom(MIN_ZOOM);
    setPosition({ x: 0, y: 0 });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleClose}
      header=""
      footer=""
      modalSize="w-full h-full sm:w-auto sm:h-auto flex justify-center md:hidden block"
    >
      <div className="relative w-full max-w-full max-h-[80vh] overflow-hidden flex items-center justify-center">
        <img
          src={imageUrl}
          alt="Preview"
          className="object-contain max-w-full max-h-[80vh] transition-transform duration-200"
          style={{
            transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
            touchAction: 'none',
          }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={() => setDragging(false)}
        />
        <div className="absolute bottom-3 right-3 flex flex-row bg-white/90 rounded shadow">
          <button
            className="p-2 disabled:opacity-40"
            onClick={() => {
              setZoom((z) => Math.max(z - ZOOM_STEP, MIN_ZOOM));
              setPosition({ x: 0, y: 0 });
            }}
            disabled={zoom <= MIN_ZOOM}
          >
            −
          </button>
          <button
            className="p-2 border-b disabled:opacity-40"
            onClick={() => setZoom((z) => Math.min(z + ZOOM_STEP, MAX_ZOOM))}
            disabled={zoom >= MAX_ZOOM}
          >
            +
          </button>
        </div>
      </div>
    </CustomModal>
  );
}
